import Modal from "./Modal.jsx";
import Button from "./Button.jsx";
import {useTranslation} from "react-i18next";
import LoadingComponent from "./LoadingComponent.jsx";

export default function YesNo({
    visible,
    setVisible,
    title,
    question,
    onYes,
    onNo,
    loading,
    dangerous = true,
    yesLabel,
    noLabel,
    yesVariant = 'outline-red',
    noVariant = 'outline-black',
    actionsGapClassName = 'gap-1',
    actionButtonClassName = 'w-28',
}) {

    let {t} = useTranslation();

    let yesPressed = () => {
        if (onYes) {
            onYes();
        }
        setVisible(false);
    };

    let noPressed = () => {
        if (onNo) {
            onNo();
        }
        setVisible(false);
    };

    let primaryButtonStyle = dangerous ? 'button-danger' : 'button-success';

    return (
        <Modal
            visible={visible}
            setVisible={setVisible}
            loading={loading}
            title={title ?? t('confirmation')}
            className={'max-w-lg'}
        >
            <div className={'text-gray-600 dark:text-gray-400 text-left text-base text-wrap'}>
                {question}
            </div>

            <div className={`flex mt-5 flex-wrap ${actionsGapClassName} justify-end`}>
                <Button
                    variant={yesVariant}
                    className={actionButtonClassName}
                    onClick={yesPressed}
                >
                    {yesLabel ?? t('yes')}
                </Button>
                <Button
                    variant={noVariant}
                    className={actionButtonClassName}
                    onClick={noPressed}
                >
                    {noLabel ?? t('no')}
                </Button>
            </div>
        </Modal>
    );
}
